export enum DashboardWidgetValueColor {
  Gray96 = 'gray-96',
  Gray98 = 'gray-98',
  Error = 'error',
}
